import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation , Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/swiper-bundle.css';
import AppImages from '../../Utils/ThemeImages';
import '../Home/Home.scss'

import starImage from '../../images/star.svg'


const TestimonialSlider = () => {

    const testimonials = [
        {
          image: AppImages.review1,
          rating: 5,
          title: 'Mohammed Ali',
          content: 'My cargo was delivered quickly and in perfect condition. The team was professional, responsive, and made the whole process simple. I’m very happy with their service and will use them again for my future shipments.'
        },
        {
          image: AppImages.review2,
          rating: 5,
          title: 'Hameed',
          content: 'They delivered my cargo on time and in great condition. The staff was helpful and professional, making the whole process smooth. I will definitely be using their services again.'
        },
        {
          image: AppImages.review3,
          rating: 5,
          title: 'Sultan',
          content: "The harbor mobile crane operator made our shipping tasks easier. They handled everything efficiently, ensuring safe and quick loading. Great support for our business."
        },
        {
          image: AppImages.review4,
          rating: 5,
          title: 'Yousuf',
          content: 'The operators helped us load and unload safely, ensuring everything was handled with care. Their service is a great asset.'
        },
        {
          image: AppImages.review1,
          rating: 5,
          title: 'Mohammed Ali',
          content: 'My cargo was delivered quickly and in perfect condition. The team was professional, responsive, and made the whole process simple. I’m very happy with their service and will use them again for my future shipments.'
        },
        {
          image: AppImages.review2,
          rating: 5,
          title: 'Hameed',
          content: 'They delivered my cargo on time and in great condition. The staff was helpful and professional, making the whole process smooth. I will definitely be using their services again.'
        },
        {
          image: AppImages.review3,
          rating: 5,
          title: 'Sultan',
          content: "The harbor mobile crane operator made our shipping tasks easier. They handled everything efficiently, ensuring safe and quick loading. Great support for our business."
        },
        {
          image: AppImages.review4,
          rating: 5,
          title: 'Yousuf',
          content: 'The operators helped us load and unload safely, ensuring everything was handled with care. Their service is a great asset.'
        },
        
      ]

  return (
    <section className="home-section-6">
        <div className="inner-home-section-6">
            <div className="container">
                <div className="top-home-sec-6-heading-part flex items-center justify-between">
                    <div className="left-head-sec-6-home wow animate__animated animate__fadeInLeft">
                        <h2 className=''>What People Tell About Us</h2>
                    </div>
                    <div className="right-buttons-section flex items-center gap-6 wow animate__animated animate__fadeInRight">
                        <div className="review-swiper-button-prev">
                            <button className='w-12 h-12 rounded-full shadow-xl bg-BlueTheme flex items-center justify-center text-white'><i className="bi bi-arrow-left text-2xl"></i></button>
                        </div>
                        <div className="review-swiper-button-next">
                            <button className='w-12 h-12 rounded-full shadow-xl bg-BlueTheme flex items-center justify-center text-white'><i className="bi bi-arrow-right text-2xl"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="swiper-home-section-6-blk">
                <Swiper
                    grabCursor={true}
                    slidesPerView={3}
                    spaceBetween={20}
                    loop={true}
                    centeredSlides={true}
                    navigation={{
                    clickable: true,
                    nextEl: '.review-swiper-button-next',
                    prevEl: '.review-swiper-button-prev',
                    }}
                    autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    }}
                    breakpoints={{
                        1700 : {
                          slidesPerView: 4 
                        },
                        1200: {
                          slidesPerView: 3
                        },
                        992: {
                          slidesPerView: 3
                        },
                        674: {
                          slidesPerView: 2
                        },
                        375: {
                          slidesPerView: 1
                        },
                        100: {
                            slidesPerView: 1
                        }
                      }}
                    modules={[ Autoplay , Navigation]}
                    className="mySwiper"
                >
                    {testimonials.map((items , index) => {
                    return (
                        <SwiperSlide key={index}>
                        <div className="testimonial-similar-slides flex flex-col gap-4">
                            <div className="top-image-review-setion flex items-center gap-4">
                                <div className="review-slide-image-sec-home">
                                <img src={items.image} alt="" />
                                </div>
                                <div className="review-content-section-home">
                                <h2>{items.title}</h2>
                                <ul className='flex items-center gap-2'>
                                    {[...Array(items.rating)].map((raters, starIndex) => (
                                    <li key={starIndex}>
                                        <img src={starImage} alt="" />
                                    </li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            <div className="bottom-para-review-sec">
                                <p className='min-h-[140px]'>{items.content}</p>
                            </div>
                        </div>
                        </SwiperSlide>
                    )
                    })}
                    <div className="custom-pagination z-10 absolute bottom-10 right-20"></div>
                </Swiper>
            </div>
        </div>
    </section>
  )
}

export default TestimonialSlider